import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'normalize.css';
import "./utils/px2rem"
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
import './assets/font/iconfont.css';
import './assets/fontAdd/iconfont.css';
import { Toast, Dialog } from 'vant';
import './assets/scss/global.scss';
Vue.prototype.$Dialog = Dialog;
import jssdk from  'weixin-js-sdk'

Vue.prototype.$wx = jssdk
Vue.prototype.$toast = Toast;

Vue.use(Vant).use(Lazyload);

Vue.config.productionTip = false;


// NodePlayer.load(() => {
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
// });
